<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 30 30"
	>
		<path d="M9.625,2.25a9.629,9.629,0,0,1,9.625,9.625A9.093,9.093,0,0,1,18.312,16,67.668,67.668,0,0,1,9.624,29.75,67.668,67.668,0,0,1,.936,16,9.093,9.093,0,0,1,0,11.875,9.629,9.629,0,0,1,9.623,2.25Zm0,14.375a4.75,4.75,0,1,0-4.75-4.75A4.748,4.748,0,0,0,9.625,16.625Z" />
	</svg>
</template>
